import { Component, Input } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module'
import { GoodsItem } from '../../../core/models/freight-document/StructuredGood'

@Component({
  selector: 'app-goods-item-inline-description',
  standalone: true,
  imports: [SharedModule],
  template: `
    <div class="border-bottom py-1">
        <span class="fw-semibold"> {{ goodsItem.name }}</span>
        <ng-container *ngIf="goodsItem.numberOfPackages || goodsItem.weight || goodsItem.netWeight || goodsItem.volume">,</ng-container>
        {{ goodsItem.numberOfPackages }} {{ goodsItem.methodOfPackaging }}
        <span *ngIf="goodsItem.weight"> {{ goodsItem.weight }}{{ goodsItem.weightUnit | weightUnit }}</span>
        <span *ngIf="goodsItem.netWeight"> {{ goodsItem.netWeight }}{{ goodsItem.netWeightUnit | weightUnit }} ({{ 'freightDocument.goods.net' | transloco }})</span>
        <span *ngIf="goodsItem.volume"> {{ goodsItem.volume }}<span [innerHTML]="goodsItem.volumeUnit | volumeUnit"></span></span>
    </div>
  `,
})
export class GoodsItemInlineDescriptionComponent {
  @Input() goodsItem: GoodsItem
}
